const lang = localStorage.getItem('locale') || 'zh';
export default {
    navList: [{
        key: 'common.关于华翔',
        text: '关于华翔',
        url: '/about',
        items: [{
            key: 'common.关于华翔',
            text: '关于华翔',
            url: '/about',
        },{
            key: 'common.廉洁合规',
            text: '廉洁合规',
            url: '/integrity'
        },/*{
            key: 'common.使命愿景',
            text: '使命愿景',
            url: ''
        },*/{
            key: 'common.荣誉奖项',
            text: '荣誉奖项',
            url: '/award'
        },{
            key: 'common.主要客户',
            text: '主要客户',
            url: '/client'
        },{
            key: 'common.全球分布',
            text: '全球分布',
            url: '/globalDistribution'
        },{
            key: 'common.合作伙伴',
            text: '合作伙伴',
            url: '/partnership'
        },{
            key: 'common.联系我们',
            text: '联系我们',
            url: '/contact'
        }]
    },{
        key: 'common.新闻资讯',
        text: '新闻资讯',
        url: '/enterprise',
        items: [{
            key: 'common.媒体报道',
            text: '媒体报道',
            url: '/news'
        },{
            key: 'common.企业新闻',
            text: '企业新闻',
            url: '/NBHXnews'
        // },{
        //     key: 'common.行业动态',
        //     text: '行业动态',
        //     url: '/business'
        }]
    },{
        key: 'common.核心业务',
        text: '核心业务',
        url: '/product',
        items: [{
            key: 'common.装饰条',
            text: '装饰条',
            url: '/productDetail?typeId=1'
        },{
            key: 'common.内外饰件',
            text: '内外饰件',
            url: '/productDetail?typeId=2'
        },{
            key: 'common.车身金属件',
            text: '车身金属件',
            url: '/productDetail?typeId=3'
        },{
            key: 'common.车身电子',
            text: '车身电子',
            url: '/productDetail?typeId=4'
        }]
    },{
        key: 'common.人力资源',
        text: '人力资源',
        url: '',
        items: [{
            key: 'common.招贤纳士',
            text: '招贤纳士',
            link: 'http://nbhx.51job.com/'
        },{
            key: 'common.人才发展',
            text: '人才发展',
            url: '/talentsDevelopment'
        }]
    },{
        key: 'common.投资者关系',
        text: '投资者关系',
        url: '',
        items: [{
            key: 'common.股票信息',
            text: '股票信息',
            link: 'http://www.szse.cn/certificate/individual/index.html?code=002048'
        },{
            key: 'common.最新公告',
            text: '最新公告',
            link: lang === 'zh' ? 'http://www.szse.cn/disclosure/listed/notice/index.html?stock=002048&name=%E5%AE%81%E6%B3%A2%E5%8D%8E%E7%BF%94' : 'http://www.cninfo.com.cn/new/snapshot/companyDetailEn?code=002048'
        },{
            key: 'common.公司治理',
            text: '公司治理',
            url: '/corporateGovernance'
        }]
    }],
    others: {
        key: 'common.关注我们',
        text: '关注我们',
        items:[/*{
            icon:'iconweibo',
            url:'https://weibo.com/p/230677sz002048'
        },*/{
            icon:require('../../assets/icon/wx.png'),
            codeUrl:require('../../assets/img/footer/wxcode.jpg')
        },{
            icon:require('../../assets/icon/phone.png'),
            url:'+86 21-68949998'/*tel:*/
        }/*,{
            icon:'iconemail-footer',
            url:'mailto:'
        }*/]
    },
}
